import React from 'react';
import { useTranslation } from 'react-i18next';
import { WEEKDAY_ORDER, WEEKDAY_LABEL_KEYS, toggleWeekday } from '../utils/recurrenceWeekdays';
import './RecurrenceWeekdayPicker.css';

/**
 * Mon–Sun toggles for task/preset recurrence.
 * `value` is number[] 0–6; `onChange(next)` receives sorted unique days.
 */
const RecurrenceWeekdayPicker = ({ value = [], onChange, disabled = false, idPrefix = 'recurrence-day' }) => {
  const { t } = useTranslation(['tasks']);
  const selected = Array.isArray(value) ? value : [];

  return (
    <div className="recurrence-weekday-picker" role="group" aria-label={t('tasks:recurrenceWeekdaysLabel')}>
      {WEEKDAY_ORDER.map((day) => {
        const isActive = selected.includes(day);
        const inputId = `${idPrefix}-${day}`;
        return (
          <button
            key={day}
            type="button"
            id={inputId}
            className={`recurrence-weekday-toggle${isActive ? ' is-active' : ''}`}
            aria-pressed={isActive}
            disabled={disabled}
            onClick={() => onChange(toggleWeekday(selected, day))}
          >
            {t(`tasks:${WEEKDAY_LABEL_KEYS[day]}`)}
          </button>
        );
      })}
    </div>
  );
};

export default RecurrenceWeekdayPicker;
